// Sub Localities list — Session C migration to the FwTable pattern.
// Same request shape as the AgTable page it replaces; columns from
// agModule.json; permission gates unchanged.
import ModuleListPage from "elements/Table/ModuleListPage";

export default function List() {
  return (
    <ModuleListPage
      module="sublocalities"
      title="Sub Localities"
      api="admin/sub-locality"
      url="sublocality"
      columnsKey="sublocalities"
      quickKey="name"
      quickPlaceholder="Filter by name…"
      localityFilter
      perms={["slr", "slc", "slu", "sld"]}
    />
  );
}
